"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultInvestorState = void 0;
var StaticContentState_1 = require("@/pages/staticContent/states/StaticContentState");
var InvestorForm_init_1 = require("@/pages/investor/states/InvestorForm.init");
var InvestorFormTranslate_init_1 = require("@/pages/investor/states/InvestorFormTranslate.init");
var EnquireState_init_1 = require("@/pages/common/states/EnquireState.init");
exports.defaultInvestorState = {
    title: 'Investors',
    sections: [
        {
            paragraphs: [
                {
                    type: StaticContentState_1.StaticContentTypes.PARAGRAPH,
                    // tslint:disable-next-line:max-line-length
                    text: 'Real estate brokerage in Asia is a multi-billion dollar industry with significant inefficiencies and a lack of transparency that impedes thousands of property agents and the millions of consumers they serve.',
                },
                {
                    type: StaticContentState_1.StaticContentTypes.PARAGRAPH,
                    // tslint:disable-next-line:max-line-length
                    text: 'OKAY.com is a real estate platform that combines the strengths of experienced technology entrepreneurs and an established corporate real estate firm, Asia Pacific Properties. Our unique business model addresses the problems faced by consumers and agents in Hong Kong. ',
                },
                {
                    type: StaticContentState_1.StaticContentTypes.PARAGRAPH,
                    // tslint:disable-next-line:max-line-length
                    text: 'Through our highly scalable proprietary enterprise software (TITAN), we have changed the way a large real estate agency runs, how information is gathered, analyzed and shared, and ultimately the quality of the consumer experience. Combined, these give us tremendous competitive advantages. ',
                },
            ],
            images: [
                '/res/img/titan.png',
            ],
            imageRight: true,
        },
        {
            paragraphs: [
                {
                    type: StaticContentState_1.StaticContentTypes.PARAGRAPH,
                    // tslint:disable-next-line:max-line-length
                    text: 'Over the last few years, we have grown rapidly in terms of our agent population, client base, revenues and market share – all amidst a market environment that has been extremely challenging for our competitors. Having successfully launched in Hong Kong, we intend to enter the China market and other markets across Asia with similar industry architecture and problems.',
                },
                {
                    type: StaticContentState_1.StaticContentTypes.PARAGRAPH,
                    // tslint:disable-next-line:max-line-length
                    text: 'We have completed initial funding rounds with highly credible investors with expertise in technology, real estate, growth ventures, finance and digital media, and welcome inquiries from investors who are interested in learning more.',
                },
            ],
            images: [
                '/res/img/media.png',
            ],
            imageRight: false,
        },
    ],
    isLoading: false,
    enquiry: InvestorForm_init_1.defaultInvestorForm,
    tForm: InvestorFormTranslate_init_1.defaultInvestorFormTranslate,
    salutations: EnquireState_init_1.defaultEnquireState.salutations,
    backgroundImage: '/res/img/about_investor.jpg',
    t: {
        investorFormTitle: 'Investor Enquiry',
        investorFormCaption: 'Send a confidential message to us below',
        // tslint:disable-next-line:max-line-length
        privacyPolicy: 'All personal information will remain strictly confidential and will be used only for communication purposes as outlined in our <a class="o-textbtn" target="_blank" href="/en/general/privacypolicy">Privacy Policy</a>',
    },
};
